import { IPrivacyService } from "../models/IPrivacyService";
import { defaultPrivacyService } from "./privacy.service";

export class GlobalPrivacyService implements IPrivacyService {

    service!: IPrivacyService;

    init(service?: IPrivacyService) {
        this.service = service || defaultPrivacyService;
    }
    isAllowed(cookieId: string): boolean {
        return this.service.isAllowed(cookieId);
    }
    getCookie(): string | undefined {
        return this.service.getCookie();
    }
    openSettings(): void {
        this.service.openSettings();
    }
}

export const PrivacyService = new GlobalPrivacyService()
